var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.85171L3.01901 9.8327C2.90748 9.94423 2.76553 10 2.59316 10C2.42079 10 2.27883 9.94423 2.1673 9.8327C2.05577 9.72117 2 9.57921 2 9.40684C2 9.23447 2.05577 9.09252 2.1673 8.98099L5.14829 6L2.1673 3.01901C2.05577 2.90748 2 2.76553 2 2.59316C2 2.42079 2.05577 2.27883 2.1673 2.1673C2.27883 2.05577 2.42079 2 2.59316 2C2.76553 2 2.90748 2.05577 3.01901 2.1673L6 5.14829L8.98099 2.1673C9.09252 2.05577 9.23447 2 9.40684 2C9.57921 2 9.72117 2.05577 9.8327 2.1673C9.94423 2.27883 10 2.42079 10 2.59316C10 2.76553 9.94423 2.90748 9.8327 3.01901L6.85171 6L9.8327 8.98099C9.94423 9.09252 10 9.23447 10 9.40684C10 9.57921 9.94423 9.72117 9.8327 9.8327C9.72117 9.94423 9.57921 10 9.40684 10C9.23447 10 9.09252 9.94423 8.98099 9.8327L6 6.85171Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseS);
export default __webpack_public_path__ + "static/media/close-s.37b2bfad544ec4eb1789194091a758d8.svg";
export { ForwardRef as ReactComponent };